export default {
  text: 'Since you last logged in, we have updated our need for info about you.',

  addInfoButton: 'Add information',
  signOut: 'Sign out'
}